export default "__VITE_ASSET__D262hJFe__"